var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dean-dialog',{staticClass:"graph",attrs:{"title":"Omzet per maand","icon":_vm.offersIcon,"align-top":""}},[_c('div',{},[_c('column-chart',{attrs:{"data":_vm.source,"colors":['#007992', '#007992']}})],1),(_vm.isLoading)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('dean-load-overlay')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }